import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { StyledNavItem } from './SecondaryNavUI';

interface IProps {
  subTitle: string;
}

const Container = styled(StyledNavItem)`
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;

const SecondaryNavSubTitle = ({ subTitle }: IProps) => (
  <Container>{subTitle}</Container>
);

export default SecondaryNavSubTitle;
